import React from "react";
import TwoColumnLayout from "layout/TwoColumnLayout";
import RightSideNavigation from "components/RightSideNavigation/RightSideNavigation";
import PanelSegmentType from "components/panels/PanelSegment/PanelSegment";
import { useLoaderData } from "react-router";
import { DetailSectionTemplate } from "components/MainSectionTemplate/DetailSectionTemplate";
import { GeneralSection } from "./generalSection";
import { ProductionSection } from "./productionSection";
import { ShowSection } from "./showSection";
import { QuoteSection } from "./quoteSection";
import { PurchaseAgreementSection } from "./purchaseAgreementSection";
import { ContractSection } from "./contractSection";
import { ESignSection } from "./esignSection";
import { InvoiceSection } from "./invoiceSection";

const ClientConfigApp = () => {
  const viewModel = useLoaderData<server.viewmodel.ClientConfigurationEditFrontModel>();

  const { clientConfiguration } = viewModel;

  const [instruction, setInstruction] = React.useState<server.dto.UpdateClientConfigurationInstruction>({
    contractDefaultDuration: clientConfiguration.contract.defaultDuration,
    contractDisplayCosts: clientConfiguration.contract.displayCosts,
    contractEnabled: clientConfiguration.contract.enabled,
    eSignEnabled: clientConfiguration.eSignEnabled,
    eSignReminderInterval: clientConfiguration.eSignReminderInterval,
    invoiceDefaultDuration: clientConfiguration.invoice.defaultDuration,
    invoiceDisplayCosts: clientConfiguration.invoice.displayCosts,
    invoiceEnabled: clientConfiguration.invoice.enabled,
    invoiceReminderInterval: clientConfiguration.invoice.reminderInterval,
    legacyInvoiceDefaultDraft: clientConfiguration.invoice.legacyDefaultDraft,
    legacyXmlFeedsEnabled: clientConfiguration.legacyXmlFeedsEnabled,
    productionEnabled: clientConfiguration.production.enabled,
    purchaseAgreementDefaultDuration: clientConfiguration.purchaseAgreement.defaultDuration,
    purchaseAgreementDisplaySales: clientConfiguration.purchaseAgreement.displaySales,
    purchaseAgreementEnabled: clientConfiguration.purchaseAgreement.enabled,
    projectCodeEnabled: clientConfiguration.projectCode === "displayInput",
    quoteDefaultDuration: clientConfiguration.quote.defaultDuration,
    quoteDisplayCosts: clientConfiguration.quote.displayCosts,
    quoteEnabled: clientConfiguration.quote.enabled,
    showDisplayCosts: clientConfiguration.show.displayCosts,
    showDisplaySales: clientConfiguration.show.displaySales,
    enableTickets: clientConfiguration.show.enableTickets,
  });

  const refresh = () => {
    window.location.reload();
  }

  const onSuccessfulUpdate = async (key: string) => {
    const keysThatRequireRefresh = [
      "production_enabled",
      "quote_enabled",
      "purchaseAgreement_enabled",
      "contract_enabled",
      "esign_enabled",
      "invoice_enabled",
    ];

    if (keysThatRequireRefresh.includes(key)) {
      refresh();
    }
  }

  const onValueChanged = (key: string, value: any) => {
    if (key === "general_projectCode") {
      setInstruction(old => ({ ...old, projectCodeEnabled: value }));
    } else if (key === "production_enabled") {
      setInstruction(old => ({ ...old, productionEnabled: value }));
    } else if (key === "show_costs") {
      setInstruction(old => ({ ...old, showDisplayCosts: value }));
    } else if (key === "show_sales") {
      setInstruction(old => ({ ...old, showDisplaySales: value }));
    } else if (key === "show_tickets") {
      setInstruction(old => ({ ...old, enableTickets: value }));
    } else if (key === "quote_enabled") {
      setInstruction(old => ({ ...old, quoteEnabled: value }));
    } else if (key === "quote_costs") {
      setInstruction(old => ({ ...old, quoteDisplayCosts: value }));
    } else if (key === "quote_dueDate") {
      setInstruction(old => ({ ...old, quoteDefaultDuration: value }));
    } else if (key === "purchaseAgreement_enabled") {
      setInstruction(old => ({ ...old, purchaseAgreementEnabled: value }));
    } else if (key === "purchaseAgreement_sales") {
      setInstruction(old => ({ ...old, purchaseAgreementDisplaySales: value }));
    } else if (key === "purchaseAgreement_dueDate") {
      setInstruction(old => ({ ...old, purchaseAgreementDefaultDuration: value }));
    } else if (key === "contract_enabled") {
      setInstruction(old => ({ ...old, contractEnabled: value }));
    } else if (key === "contract_costs") {
      setInstruction(old => ({ ...old, contractDisplayCosts: value }));
    } else if (key === "contract_dueDate") {
      setInstruction(old => ({ ...old, contractDefaultDuration: value }));
    } else if (key === "esign_enabled") {
      setInstruction(old => ({ ...old, eSignEnabled: value }));
    } else if (key.startsWith("esign_reminder_")) {
      const index = parseInt(key.match(/\d+/)[0]) - 1;
      const newIntervals = [...instruction.eSignReminderInterval];
      newIntervals[index] = value;
      setInstruction(old => ({ ...old, eSignReminderInterval: newIntervals }));
    } else if (key === "invoice_enabled") {
      setInstruction(old => ({ ...old, invoiceEnabled: value }));
    } else if (key === "invoice_costs") {
      setInstruction(old => ({ ...old, invoiceDisplayCosts: value }));
    } else if (key === "invoice_dueDate") {
      setInstruction(old => ({ ...old, invoiceDefaultDuration: value }));
    } else if (key.startsWith("invoice_reminder_")) {
      const index = parseInt(key.match(/\d+/)[0]) - 1;
      const newIntervals = [...instruction.invoiceReminderInterval];
      newIntervals[index] = value;
      setInstruction(old => ({ ...old, invoiceReminderInterval: newIntervals }));
    } else if (key === "invoice_draftDefault") {
      setInstruction(old => ({ ...old, legacyInvoiceDefaultDraft: value }));
    } else {
      console.warn("Unknown key changed: " + key);
      console.warn("Value: " + value);
    }


  }
  viewModel.clientConfiguration.projectCode
  return <>
    <PanelSegmentType>
      <PanelSegmentType.Header size="h1header">
        <PanelSegmentType.Title title={RESX.GeneralLabels.SystemConfiguration} />
      </PanelSegmentType.Header>
    </PanelSegmentType>

    <TwoColumnLayout>
      <TwoColumnLayout.LeftColumn>
        <DetailSectionTemplate
          onValueChanged={onValueChanged}
          onSuccessfulUpdate={onSuccessfulUpdate}
          isInPageEditable
          sections={[
            GeneralSection({ instruction, config: clientConfiguration }),
            ProductionSection({ instruction }),
            ShowSection({ instruction }),
            QuoteSection({ instruction }),
            PurchaseAgreementSection({ instruction }),
            ContractSection({ instruction }),
            ESignSection({ instruction }),
            InvoiceSection({ instruction }),
          ]}
        />
      </TwoColumnLayout.LeftColumn>
      <RightSideNavigation
        title={site.navigation.rightSideNavigation.title}
        menuItems={site.navigation.rightSideNavigation.items}
        currentPage={site.currentPage}
      />
    </TwoColumnLayout>
  </>;
};

export default ClientConfigApp;